import React, { useEffect, useState } from 'react';
import { Download, FileDown } from 'lucide-react';
import BrochureLeadDialog from './BrochureLeadDialog';

/**
 * Bouton flottant collant en bas de page. Il n'exécute plus le téléchargement
 * directement : il ouvre un modal qui collecte prénom + e-mail (lead capture)
 * avant de lancer le download.
 */
export default function StickyBrochureButton() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {visible && (
        <div
          className="fixed bottom-6 right-6 z-40 animate-in fade-in slide-in-from-bottom-4 duration-300"
          data-testid="sticky-brochure-wrapper"
        >
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid="sticky-brochure-btn"
            className="group flex items-center gap-3 bg-[#C77D63] hover:bg-[#b06a51] text-white rounded-full pl-5 pr-6 py-4 shadow-2xl shadow-[#C77D63]/40 transition-all hover:scale-[1.03] active:scale-100"
          >
            <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
              <Download className="w-4 h-4" />
            </span>
            <span className="text-sm font-semibold whitespace-nowrap">
              Télécharger la brochure PDF
            </span>
          </button>
        </div>
      )}
      <BrochureLeadDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
